export default "/images/4dfe2c0c3431aaacb8365376404499f9.avif";